/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * The returned Promise fails if privacy terms are not accepted and resolves if they are accepted.
 */
export const isPrivacyConsentAccepted = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if ((window as any)?.trumpf?.ux?.uiPrivacyConsent) {
            const hasConsented = (
                window as any
            ).trumpf.ux.uiPrivacyConsent.hasConsented();
            if (hasConsented) {
                resolve();
            } else {
                reject();
            }
            return;
        }
        reject();
    });
};
